import type { Engine } from '../../engine';
import { Plugin } from '../plugin';

export class ParticleLoader extends Plugin {
  engine: Engine;
}
